module.exports = __webpack_public_path__ + "img/store7.82db4565.png";